import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { CreateProjectFieldEl } from "common/widgets/create-project-field";
export function template() {
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".project-creation", attrs: {
    open: this.attr("open")
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-content" }, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-title" }, this.getContext("i18n").t("settings.project-settings.create.title")), /* @__PURE__ */ jsx(CreateProjectFieldEl, { attrs: {
    "organization-id": this.attr("organization-id"),
    orgs: this.attr("orgs"),
    "is-setup": this.attr("is-setup"),
    "project-id": this.attr("project-id")
  }, on: {
    cancel: () => this.dispatchEvent(new CustomEvent("cancel")),
    create: (evt) => this.dispatchEvent(new CustomEvent("create", {
      detail: evt.detail
    }))
  }, "data-sentry-element": "CreateProjectFieldEl", "data-sentry-source-file": "template.tsx" })));
}
